import { render, staticRenderFns } from "./PShare.vue?vue&type=template&id=4838461b&scoped=true&"
import script from "./PShare.vue?vue&type=script&lang=js&"
export * from "./PShare.vue?vue&type=script&lang=js&"
import style0 from "./PShare.vue?vue&type=style&index=0&id=4838461b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4838461b",
  null
  
)

export default component.exports